export const REMOTE_DESKTOP_EXERCISE = 'RemoteDesktopExercise';
export const EXPORTED_EXERCISES = [REMOTE_DESKTOP_EXERCISE];